exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-121ded2c] .v-list-item__action{display:none!important}", ""]);
